import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';
import * as d3 from 'd3';
import axios from 'axios';
import { DomainModel } from '@/models/proficiency/domain';
import { CompetencyModel } from '@/models/proficiency/competency';
import { sessionService } from '@/providers/services/auth/session';
import { competencyAPI } from '@/providers/apis/competency/competency';
import { sortByProperty } from '@/utils/utils';

@Component({
    name: 'competency-chart-card',
})

export default class CompetencyChartCard extends Vue {

    // ----------------------------------------------------------------
    // Properties
    @Prop()
    private subjectCode: any;

    private month: string = moment().format('MM');

    private year: string = moment().format('YYYY');

    private domainMatrix?: any = [];

    private isLoading: boolean = false;

    private userId() {
        const session = sessionService.getSession();
        return session ? session.user_id : '';
    }


    @Watch('subjectCode')
    private watchSubjectCode(code: any) {
        this.loadProficiencyData(code);
    }

    // -----------------------------------------------------------------
    // Hooks
    private mounted() {
        this.loadProficiencyData(this.subjectCode);
    }

    // ------------------------------------------------------------------
    // Methods

    private drawLineChart(data: any) {
        d3.select(this.$el).select('svg').remove();
        const width = this.$el.clientWidth;
        const height = 150;
        // append the svg object to the body of the page
        const svg = d3.select(this.$el)
            .append('svg')
            .attr('width', width)
            .attr('height', height)
            .append('g')
            .attr('transform', 'translate(' + 0 + ',' + 0 + ')');

        const maxValue: any = d3.max(data, (d: any) => d.totalCompetencies);

        const barPadding = 2;
        const barWidth = (width / data.length);

        svg.selectAll('rect')
            .data(data)
            .enter()
            .append('rect')
            .attr('y', (d: any) => {
                return (100 - ((d.totalCompetencies / maxValue) * 100)) + '%';
            })
            .attr('height', (d: any) => {
                return (d.totalCompetencies / maxValue) * 100 + '%';
            })
            .attr('width', (barWidth - barPadding) > 0 ? (barWidth - barPadding) : 0)
            .style('fill', '#016aae')
            .attr('transform', (d, i) => {
                const translate = [barWidth * i, 0];
                return 'translate(' + translate + ')';
            });
    }

    private loadProficiencyData(subjectCode: any) {
        const domainMatrixPromise = this.fetchUserDomainCompetencyMatrix(subjectCode);
        this.isLoading = true;
        axios.all([domainMatrixPromise]).then(
            axios.spread(async (domainMatrix: any) => {
                sortByProperty(domainMatrix, 'domainSeq', 'ASC');
                this.domainMatrix = domainMatrix;
                this.isLoading = false;
                this.drawLineChart(domainMatrix);
            }));
    }

    private fetchUserDomainCompetencyMatrix(subjectCode: string) {
        const params = {
            user: this.userId(),
            subject: subjectCode,
            month: Number(this.month),
            year: Number(this.year),
        };
        return competencyAPI.fetchDomainTopicCompetencyMatrix(params);
    }

}
